import React from 'react';
import T from 'prop-types';

import SimpleDropdown from './Dropdowns/SimpleDropdown';

const periodChangeTypeOptions = [
  {
    value: 'year_over_year',
    label: 'Year-over-Year',
    shortLabel: 'YoY',
  },
  {
    value: 'period_over_period',
    label: 'Period-over-Period',
    shortLabel: 'PoP',
  },
];

export const periodChangeTypeCaptures = {
  year_over_year: 'YoY',
  period_over_period: 'PoP',
};

const OverPeriodDropdown = ({
  selected,
  disabled,
  appendOptions,
  valueDecorator,
  menuAlign,
  onChange,
}) => {
  const typeOptions = periodChangeTypeOptions.concat(appendOptions || []).map((option) => ({
    ...option,
    className: 'menu-item--14',
  }));

  const options = valueDecorator
    ? typeOptions.map((option) => ({ ...option, value: valueDecorator(option.value) }))
    : typeOptions;

  return (
    <SimpleDropdown
      selected={selected}
      options={options}
      disabled={disabled}
      isActiveSelectable={false}
      menuWidth={221}
      menuAlign={menuAlign}
      onChange={onChange}
    />
  );
};

OverPeriodDropdown.propTypes = {
  selected: T.string.isRequired,
  disabled: T.bool,
  appendOptions: T.arrayOf(
    T.shape({
      label: T.string,
      value: T.string,
    })
  ),
  valueDecorator: T.func,
  menuAlign: T.string,
  onChange: T.func.isRequired,
};

export default OverPeriodDropdown;
